export class PartecipantiCarrello {
	ItemID: number | null;
	Nome: string;
	Cognome: string;
	CodiceFiscale: string;
	DataNascita: Date | null;
	Email?: string;
	Residenza?: string;
}